<template>
  <div>
      <div v-for="(val,i) in value">
        <v-row class="array_input">
          <v-col class="pl-8">
            <Input
              :readonly="readonly"
              :value="val"
              :roles="roles"
              :name="value.id || ' '"
              name_readonly
              @update="(val) => update(i,val)"
            />
          </v-col>
        </v-row>
      </div>
      <AddValue
        v-if="!readonly"
        @submit="update_add"
      />
  </div>
</template>

<style lang="scss">
  .array_input{
    border:1px;
    border-width: 1px;
    border-color: black;
  }
</style>

<script>
  export default {
    components: {
      Input: () => import('@/components/bpcreator/inputs/Input'),
      AddValue: () => import('@/components/bpcreator/model/AddValue'),
    },
      
    name: 'ArrayInput',
      
    props: {
      name: {},
      value: {default: () => ({})},
      readonly: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
    }),
      
    computed: {
    },
      
    mounted() {
    },
      
    methods: {
      update_add(values) {
        this.update(this.value.length || 0, values.default_value);
      },

      update(pos,value) {
        let res = this.value;
        if (this.value.length > pos) {
          res[pos] = value;
        } else {
          res.push(value)
        }
        this.$emit('update',res);
      },
    },
  }
</script>